class PersistentBanner extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    this.section_id = this.getAttribute("data-section-id");
    const user_default_state = sessionStorage.getItem(this.section_id);  
    
    this.toggle = this.querySelector('.collapsible-row--toggle');
    this.default_state = 'true' === this.toggle.getAttribute('aria-expanded');   
    if (user_default_state != null) {
      this.default_state = 'true' === user_default_state;
    }     
    
    this.description = this.querySelector('.collapsible-row--content');    
    this.description_wrapper = this.querySelector('.collapsible-row--content-wrapper');
    
    this.toggleListener();  
    this.setTransitions(this.default_state);
  }
  disconnectedCallback () {
    this.toggle.off('click keydown')
  }
  toggleListener () {
    const section_id = this.section_id;
    this.toggle.on('click keydown', e => {
      console.log('click');
      const set_state = ('true' !== this.toggle.getAttribute('aria-expanded'));
      ('keydown' === e.type && 'Enter' !== e.key) ||
        (e.preventDefault(),
         sessionStorage.setItem(section_id, set_state),
         this.setTransitions(
           set_state
         ));
    })
  }
  setTransitions (e) {
    this.toggle.setAttribute('aria-expanded', e),
      this.description_wrapper.setAttribute('data-transition-active', e),
      (this.description_wrapper.style.height = e
        ? this.description.offsetHeight + 'px'
        : '30px')
  }
}
const persistBannerEl = customElements.get('persistent-banner')
persistBannerEl || customElements.define('persistent-banner', PersistentBanner)
